import {configureStore} from '@reduxjs/toolkit';
import authReducer from './slices/auth.slice';
import ActualiteReducer from './slices/actualites.slice';
import EventReducer from './slices/evenements.slice';
import MembreReducer from './slices/membres.slice';
import UserReducer from './slices/users.slice';
import GalerieReducer from './slices/galeries.slice';
import CarousselReducer from './slices/carrousel.slice';
import PieceJointeReducer from './slices/piecejointes.slice';
import SpeakerReducer from './slices/speaker.slice';
import CompteRenduReducer from './slices/compteRendu.slice';

export const store = configureStore ({
  reducer: {
    auth: authReducer,
    actualites: ActualiteReducer,
    event: EventReducer,
    membre: MembreReducer,
    users: UserReducer,
    galeries: GalerieReducer,
    caroussel: CarousselReducer,
    piecejointe: PieceJointeReducer,
    speaker: SpeakerReducer,
    compteRendu: CompteRenduReducer,
  },
  devTools: true,
});
